<template>
  <!-- Begin - Temp Help Screen Modal -->
  <v-dialog
    v-model="visible"
    max-width="500px"
    @click:outside="close()"
  >
    <v-card>
      <v-card-title class="justify-center title">
        OAT / Dewpoint Help
      </v-card-title>
      <v-card-text>
        <span class="subtitle-2">OAT and Dewpoint can be input in (3) formats, to provide flexibility without having to do manual conversions.  The following are the (3) accepted formats:</span>
        <v-container>
          <v-row>
            <v-col cols="3">
              <span>20</span><br />
            </v-col>
            <v-col cols="9">
              <span>Number only, [celcius] temp.</span><br />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <span>20C</span><br />
            </v-col>
            <v-col cols="9">
              <span>Number with a letter 'C', [celcius] temp.</span><br />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <span>45F</span><br />
            </v-col>
            <v-col cols="9">
              <span>Number with a letter 'F', [farenheit] temp.</span><br />
            </v-col>
          </v-row>

        </v-container>
        </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="primary"
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- End - Temp Help Screen Modal -->
</template>

<script>
  export default {
    name: "TempHelp",
      data() {
        return {

      }
    },
    props: {
      visible: {type:Boolean, required: true}
    },
    methods:{
      close() {
        this.$emit('close');
      },
    }
  };
</script>
